var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row", attrs: { id: "trivia" } },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 trivia-header" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trivia-progress" },
            [
              _c("progress-bar", {
                attrs: { percent: _vm.triviaProgressPercent, height: 12 },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "progress-text" },
                [
                  _vm._v("\n        " + _vm._s(_vm.answeredTriviaQuestions)),
                  _c("slash", { staticClass: "progress-slash" }),
                  _c("span", { staticClass: "all-count" }, [
                    _vm._v(_vm._s(_vm.allTriviaQuestions)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.triviaComplete
        ? _c(
            "div",
            { staticClass: "col-xs-10 col-xs-offset-1" },
            [_c("empty-state")],
            1
          )
        : _c("trivia-question", {
            key: _vm.questionKey,
            attrs: { question: _vm.currentTriviaQuestion },
            on: { next: _vm.nextQuestion },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }